import React from "react";
import { Link } from "react-router-dom";
import ImageLoader from "../../other-components/ImageLoader";
import general from "../../css/General.module.css";
import style from "./style.module.css";

function Modal({ title, description, data, spaceAbove }) {
    return (
        <div className={`${style.parentView} ${spaceAbove ? style.space1X : ''}`}>
            {title ?
                <div className={style.headerView}>
                    <h2>{title}</h2>
                    <p dangerouslySetInnerHTML={{ __html: description }} />
                </div>
                : null
            }

            <div className={[style.contentsView].join(" ")}>
                {data != null
                    ?
                    data.map((data, index) => (
                        <Link
                            key={"v2_" + index}
                            className={[style.item].join(" ")}
                            to={{
                                pathname: "/search",
                                search: `?q=${encodeURIComponent(data["item_link_id"])}&d=${encodeURIComponent(data["item_title"])}&linked=true`
                            }}
                        >
                            <ImageLoader
                                className={`${style.image} lazy-loading`}
                                src={data["item_media"]}
                                alt={data["item_media"]}
                            />

                            <h6 className={[style.title, general.wClac90, general.overflowHiddenEllipsis].join(" ")}>{data["item_title"]}</h6>

                            <div className={[style.description].join(" ")} dangerouslySetInnerHTML={{ __html: data["item_description"] }}></div>
                        </Link>
                    ))
                    : ""}

            </div>
        </div>
    );
}

export default Modal;